import axios from "axios";
import { store } from "./store";
import { loaderActions } from "./store/slices/loaderSlice";
import { warningActions } from "./store/slices/WarningSlice";

axios.interceptors.request.use(function (request) {
  store.dispatch(loaderActions.fetching());
  const tenant = store.getState().pod.resourceName;
  if (tenant) {
    request.headers["X-Tenant"] = tenant;
  }
  return request;
});

axios.interceptors.response.use(
  function (response) {
    store.dispatch(loaderActions.fetched());
    return response;
  },
  function (error) {
    store.dispatch(loaderActions.fetched());
    store.dispatch(warningActions.showWarning({}));
    if (error.response.status === 401) {
      //
    }
    return Promise.reject(error);
  }
);

export default axios;
